import sakq from "@/views/download/Sakq";

const routes=[
    {
        path: "/download/sakq",
        name: "sakq",
        meta: {
            title: "下载"
        },
        component: sakq
    },
];

export default routes;
